import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/layout/Breadcrumbs";

const sections = [
  ["Acceptance of Terms", "By booking a taxi or using our website, you agree to these terms and conditions. Please read them carefully before making a booking."],
  ["Bookings & Confirmation", "All bookings are subject to vehicle availability and confirmation by our team. A booking request submitted online is confirmed once we contact you by phone or WhatsApp."],
  ["Fares & Payment", "Fares are quoted based on distance, vehicle type and trip type. Additional charges such as tolls, parking, state taxes and night driving may apply and will be communicated in advance. Final fares are confirmed at the time of booking."],
  ["Cancellation", "Bookings can be cancelled by informing us in advance. Cancellation charges may apply for confirmed outstation trips depending on timing. Please contact us as early as possible."],
  ["Responsibilities", "Passengers are expected to travel safely and respectfully. We are not responsible for delays caused by traffic, weather, road conditions or events beyond our control. Any illegal items or activities during the journey are strictly prohibited."],
  ["Liability", "We take all reasonable care to provide safe and reliable service. However, we are not liable for indirect losses arising from delays or circumstances beyond our reasonable control."],
  ["Contact", "For any questions about these terms, contact us at 099829 03736 or info@chouhantaxiservice.com."],
];

export default function Terms() {
  return (
    <>
      <Seo title="Terms & Conditions | Chouhan Taxi Service" description="Read the terms and conditions for booking taxi and tour services with Chouhan Taxi Service." path="/terms-conditions" />
      <Breadcrumbs items={[{ label: "Terms & Conditions" }]} />
      <section className="section-pad pt-8">
        <div className="container-x max-w-3xl">
          <h1 className="text-3xl sm:text-4xl font-heading font-extrabold text-navy-heading">Terms & Conditions</h1>
          <p className="mt-3 text-sm text-slate-400">Last updated: January 2025</p>
          <div className="mt-8 space-y-8">
            {sections.map(([h, b]) => (
              <div key={h}>
                <h2 className="font-heading font-bold text-navy-heading text-xl mb-2">{h}</h2>
                <p className="text-slate-600 leading-relaxed">{b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
